module.exports = __webpack_public_path__ + "static/media/approve.d885ccfe.svg";